<template>
  <div class="layout-container desktopMaxW-xxs">
    <div class="text-center mb-50 pt-18">
      <img src="/icons/glasses.svg" class="inline-block w-32 h-32 mb-16">
      <div class="type-headline-xl mb-12">{{ $t('lockedPage.headline') }}</div>
      <div class="type-sm">{{ $t('lockedPage.text') }}</div>
    </div>
    <SigninModal
      :as-modal="false"
      :stay-on-page="true"
      :force-reload="true"
      class="mb-64"
    />
  </div>
</template>

<script setup lang="ts">
import SigninModal from '~/components/account/SigninModal.vue';
</script>

<style scoped lang="postcss">
</style>
